module.exports = __webpack_public_path__ + "img/TS6102-304.be607ab8.jpg";